export const amendmentPropsRows = [
  {
    type: 'string',
    title: 'Номер',
    value: 'number',
    prop: 'number',
    placeholder: '',
    propName: null
  },
  {
    type: 'date',
    title: 'Дата',
    value: null,
    prop: 'date',
    placeholder: '',
    propName: null
  },
  {
    type: 'select',
    selectType: 'multi',
    title: 'Типы ДС',
    value: 'amendment_types',
    prop: 'amendment_amendment_types',
    propName: 'amendment_amendment_types',
    idName: 'amendment_type_id'
  },
  {
    type: 'mandatory_files',
    selectType: 'multi',
    title: 'Обязательные категории документов',
    value: 'file_types',
    prop: 'mandatory_file_types',
    propName: 'mandatory_file_types',
    idName: 'file_type_id'
  }
]

export const amendmentsComplexFields = [
  ...amendmentPropsRows
    .filter(r => r.selectType === 'multi')
    .map(({ prop, idName }) => [prop, idName])
]
